import { all } from "redux-saga/effects"
import list from "./list"
import read from "./read"

export default function* saga() {
  while (true) {
    yield all({
      read: read(),
      list: list(),
    })
  }
}
